import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { CheckCircleOutlined as CheckIcon } from '@mui/icons-material';
import { navigate } from '../lib/navigation';
import Button from './Button';
import LogoMark from './LogoMark';

const content = {
  signup: {
    title: 'Be ready when the right UGC opportunity arrives.',
    description: 'Build one professional profile with the work, audience, and experience brands need to understand your fit.',
    benefits: ['Keep your UGC samples ready to share', 'Show your niches, audience, and past work', 'Respond faster when a relevant brief arrives'],
  },
  login: {
    title: 'Keep your CreatorCV ready for the next UGC opportunity.',
    description: 'Update your work, audience insights, and availability so your profile is ready when a relevant brief arrives.',
    benefits: ['Add your latest UGC samples', 'Keep your audience insights current', 'Share one profile with brands'],
  },
};

function AuthPageLayout({ variant, children }) {
  const copy = content[variant];

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: { xs: 2, sm: 3, md: 5 } }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 1080,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1.08fr 0.92fr' },
          bgcolor: 'background.paper',
          borderRadius: { xs: 3, md: 4 },
          overflow: 'hidden',
          boxShadow: '0 18px 60px rgba(38, 24, 76, 0.12)',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            color: 'white',
            background: 'linear-gradient(145deg, #21153F 0%, #4E28B5 58%, #7C5CD6 100%)',
            p: { xs: 3, sm: 5, md: 7 },
            display: 'flex',
            alignItems: 'center',
            minHeight: { md: 620 },
            '&::after': {
              content: '""',
              position: 'absolute',
              width: 300,
              height: 300,
              borderRadius: '50%',
              right: -120,
              bottom: -150,
              bgcolor: 'rgba(255,255,255,0.08)',
            },
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 470 }}>
            <Typography variant="h3" sx={{ fontSize: { xs: '1.65rem', sm: '2.25rem', md: '2.65rem' }, lineHeight: 1.15, mb: 2 }}>
              {copy.title}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.78)', fontSize: { xs: '0.95rem', sm: '1.08rem' }, lineHeight: 1.65 }}>
              {copy.description}
            </Typography>
            <Stack spacing={1.5} sx={{ mt: 4, display: { xs: 'none', sm: 'flex' } }}>
              {copy.benefits.map((benefit) => (
                <Stack key={benefit} direction="row" spacing={1.25} sx={{ alignItems: 'center' }}>
                  <CheckIcon sx={{ color: '#B9A8F2', fontSize: 21 }} />
                  <Typography fontWeight={600}>{benefit}</Typography>
                </Stack>
              ))}
            </Stack>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            placeItems: 'center',
            minHeight: { md: 620 },
            px: { xs: 3, sm: 5, md: 6 },
            pt: { xs: 6, sm: 8, md: 9 },
            pb: { xs: 9, sm: 10, md: 11 },
          }}
        >
          <Card elevation={0} sx={{ width: '100%', maxWidth: 420, bgcolor: 'transparent' }}>
            <CardContent sx={{ p: '0 !important' }}>
              <Button
                variant="secondary"
                onClick={() => navigate('/')}
                sx={{ mb: 4 }}
              >
                ← Back to CreatorCV home
              </Button>
              <Box sx={{ mb: 3.5 }}>
                <LogoMark />
              </Box>
              {children}
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}

export default AuthPageLayout;
